<section aria-label="Schenkwerk Gutscheine" class="app-canvas min-h-screen flex flex-col bg-white">
  @if (!hideInstallPrompt) {
    <app-install-prompt></app-install-prompt>
  }
  <!-- Environment banner — dismissible for the rest of the day -->
  @if (envBanner && !envBannerHidden) {
    <div
      [class]="
        'relative z-50 flex items-center gap-3 px-4 py-2 text-sm font-medium ' + envBanner.theme
      ">
      <div class="flex flex-1 items-center justify-center gap-2">
        <ng-icon [name]="envBanner.icon" />
        <span>{{ envBanner.label }}</span>
      </div>
      <button
        type="button"
        class="shrink-0 text-current underline underline-offset-4 hover:no-underline"
        (click)="hideEnvBannerForToday()">
        heute ausblenden
      </button>
    </div>
  }

  <!-- An agency working in a client's account: always visible, never dismissible -->
  @if (authService.actingPartnerName(); as partner) {
    <div
      class="bg-primary text-primary-foreground relative z-50 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 px-4 py-2 text-sm"
      role="status">
      <span class="flex items-center gap-2">
        <ng-icon name="lucideHandshake" />
        <span>
          Du arbeitest als <strong>{{ partner }}</strong> im Konto von
          <strong>{{ authService.companyName() || 'deinem Kunden' }}</strong
          >.
        </span>
      </span>
      <button
        type="button"
        class="flex items-center gap-1 underline underline-offset-4 hover:no-underline"
        (click)="authService.leaveActingSession()">
        <ng-icon name="lucideArrowLeft" />
        Zurück zum Partnerbereich
      </button>
    </div>
  }

  @if (!hideNavbar) {
    <app-navbar (onMobileMenuToggle)="toggleScrollLock($event)"></app-navbar>
  }
  @if (!hideNotifications) {
    <app-notifications />
  }
  <router-outlet></router-outlet>

  @if (!hideFooter) {
    <app-footer class="mt-auto"></app-footer>
  }
</section>
